

































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import {maxLength, required} from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Toast from '@/shared/services/toast';
import ReadonlyField from '@/shared/components/ReadonlyField.vue';
import Modal from '@/shared/components/Modal.vue';
import {UpdateContactAttributeViewModel} from '@/messaging/models/updateContactAttributeViewModel';
import {ContactAttributeViewModel} from '@/messaging/models/contactAttributeViewModel';
import {ContactAttributeType} from '@/messaging/models/contactAttributeType';
import {UPDATE_CONTACT_ATTRIBUTE} from '@/store/attributes/actionTypes';
const validName = (value: string) => value.search(/[^a-zA-Z0-9 _\-]/) === -1;
@Component({
	components: {
		ReadonlyField,
		Modal
	},
	mixins: [validationMixin],
	validations: {
		request: {
			description: {
				required,
				maxLength: maxLength(255)
			},
			name: {
				required,
				validName,
				maxLength: maxLength(50)
			}
		}
	}
})
export default class UpdateAttribute extends Vue {
	@Prop() public attribute: ContactAttributeViewModel;
	@Action(UPDATE_CONTACT_ATTRIBUTE) public updateAttribute: (request: { attributeId: string, request: UpdateContactAttributeViewModel }) => Promise<ContactAttributeViewModel>;
	public request: UpdateContactAttributeViewModel = { description: '', name: '' };

	public updateInProgress: boolean = false;

	@Watch('attribute', { immediate: true })
	public onAttributeChange(to: ContactAttributeViewModel, from: ContactAttributeViewModel) {
		this.request.description = to.description;
		this.request.name = to.name;
	}

	public mounted() {
		const nameInput = (this.$refs.nameInput as any);
		if (nameInput) {
			nameInput.focus();
		}
	}

	public closeModal() {
		this.$emit('cancel');
	}

	public isFieldNotPopulated(vuelidateObject: any, fieldName: string): boolean {
		const field = vuelidateObject[fieldName];
		return !field || (field.$invalid && !field.required && field.$dirty);
	}

	public isFieldInvalid(vuelidateObject: any, fieldName: string): boolean {
		const field = vuelidateObject[fieldName];
		return !field || (field.$invalid && field.$dirty);
	}

	public get submitDisabled() {
		return this.$v.$invalid || this.attribute.description === this.request.description && this.attribute.name === this.request.name;
	}

	public get attributeType() {
		return Object.keys(ContactAttributeType).filter(x => (ContactAttributeType as any)[x] === this.attribute.type)[0];
	}

	public async update() {
		if (this.updateInProgress) {
			return;
		}

		this.updateInProgress = true;
		try {
			const updatedAttribute = await this.updateAttribute({attributeId : this.attribute.id, request: this.request });
			Toast.showSuccess('Attribute successfully updated');
			this.$emit('update', updatedAttribute);
		} catch (err) {
			Toast.showError(err.message);
		} finally {
			this.updateInProgress = false;
		}
	}
}
